import configureStore from './configureStore'
import { loadState,saveState } from './localStorage'

const preloadedState = loadState();
const store = configureStore(preloadedState)
store.subscribe(()=>{saveState({});})
export { store }